import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { HISTORY_ITEM_ACTION_TYPES } from '../../pages/constants/cmConstants';
import { toggleALertNote } from '../../redux/actions/cm/alertDetails';

import {
  ADD_ALERT_NOTE,
  addAlertNoteSuccess,
  addAlertNoteFail,
  FETCH_ALERT_NOTE_HISTORY,
  fetchAlertNoteHistorySuccess,
  fetchAlertNoteHistoryFail
} from '../../redux/actions/cm/alertNote';

import { addAlertNote } from '../../services/cm/alerts';
import { fetchHistoryForAlert } from '../../services/cm/historyItems';

function* addAlertNoteWorker({ alertId, alertNote }) {
  try {
    yield call(addAlertNote, { alertId, alertNote });
    yield put(addAlertNoteSuccess());
    yield put(toggleALertNote({ isOpen: false }));
  } catch (error) {
    yield put(addAlertNoteFail());
  }
}

export function* watchAddAlertNote() {
  yield takeEvery(
    ADD_ALERT_NOTE,
    function* ({ payload: { alertId, alertNote } }) {
      yield fork(addAlertNoteWorker, { alertId, alertNote });
    }
  );
}

function* fetchAlertNoteHistoryWorker({ alertId }) {
  try {
    const { items } = yield call(fetchHistoryForAlert, {
      alertId,
      actionType: HISTORY_ITEM_ACTION_TYPES.ADD_NOTE
    });
    yield put(
      fetchAlertNoteHistorySuccess({ list: items, total: items.length })
    );
  } catch (error) {
    yield put(fetchAlertNoteHistoryFail());
  }
}

export function* watchfetchAlertNoteHistory() {
  yield takeEvery(
    FETCH_ALERT_NOTE_HISTORY,
    function* ({ payload: { alertId } }) {
      yield fork(fetchAlertNoteHistoryWorker, { alertId });
    }
  );
}
